/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";

const RHFDropdown = ({ formData, control }) => {
    // Generate validation rules dynamically
    const rules = formData?.Validations?.reduce((acc, validation) => {
        if (validation.ValidationType === "Required") {
            acc.required = validation.ValidationMessage || "This field is required";
        }
        return acc;
    }, {});

    return (
        <Controller
            name={formData?.ValueExpr}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) => (
            

              

                    <Autocomplete
                        {...field}
                        options={formData?.DefaultValues || []}
                        renderOption={(props, option) => (
                            <li {...props} key={option[formData?.ValueExpr]} style={{ fontSize: '13px' }}>
                                {option[formData?.DisplayExpr]}
                            </li>
                        )}
                        getOptionLabel={(option) => option[formData.DisplayExpr] || ""}
                        isOptionEqualToValue={(option, value) =>
                            option[formData.ValueExpr] === value[formData.ValueExpr]
                        }
                    value={field.value}
                    onChange={(event, value) =>
                            field.onChange(value)
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={<>{formData?.LabelName || formData?.DisplayExpr}{rules?.required && (
                                    <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                )}</>}
                                variant="outlined"
                                size="small"
                                // error={!!error}
                                helperText={
                                    error && <span style={{ color: "red", fontSize: "10px" }}>{error.message}</span>
                                }
                                fullWidth
                                sx={{
                                    "& .MuiInputBase-input": {
                                        fontSize: "13px",
                                    },
                                    "& .MuiFormLabel-root": {
                                        fontSize: "14px",
                                    },
                                }}
                            />
                        )}
                    />
                
            
                
            )}
        />
    );
};

export default RHFDropdown;
